import {useEffect, useState} from 'react'

function FJLazy(props) {
  const {shown, render} = props;
  const [hasShown, updateStatus] = useState(false);
  useEffect(() => {
    if (!hasShown && shown) {
      updateStatus(true);
    }
  });

  return hasShown ? render(shown) : null;
}

export default FJLazy;